import { Select, styled } from "@mui/material";

const SelectField = styled(Select)(({ theme}) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& fieldset': {
    border: 'none'
  },
  '&.MuiInputBase-root': {
    border: "1px solid #F0F1F5",
    borderRadius: 5,
    backgroundColor: "#FFFFFF",
    paddingRight: "12px",
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    width: '100%',
    boxSizing: 'border-box',
    minHeight: '42px', // Add fixed height
    display: 'flex', // Add flex display
    alignItems: 'center', // Center items vertically

    '&.Mui-disabled': {
      backgroundColor: '#F0F1F5',
    },

    '&:before, &:after': {
      content: 'none'
    }
  },
  '& .MuiInputBase-input': {
    position: 'relative',
    fontSize: 16,
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: "transparent", // Changed from white to transparent
    padding: '10px 12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),

    '&.Mui-disabled': {
      backgroundColor: 'transparent',
    },
    '&::placeholder': {
      textTransform: 'capitalize',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      fontStyle: 'normal',
    },
  },
  // Add styles for the selected items container
  '& .MuiSelect-select': {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  '& .MuiSelect-multiple': {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    paddingRight: '24px', // Make space for dropdown icon
  },
  // Style for individual selected chips in multiple select
  '& .MuiChip-root': {
    maxWidth: 'calc(100% - 8px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0
  }
}));

export default SelectField;